import React from 'react'
import'./Footer.css'
import { FaLinkedin } from "react-icons/fa";
import { FaInstagramSquare } from "react-icons/fa";
import { FaWhatsappSquare } from "react-icons/fa";

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <div className='footer_div'>
         <div className='backdiv'>
            <div className='footer_grid'>
              <div>
  <div className='footer_logo'>
 <img className='f_logo' src='./zweedo-logo-removebg.webp' alt='logo' loading='lazy' />
</div>
</div>
<div>
   <h5 className='f_text1'>Navigation</h5>
   <a href='/'>
    <p className='f_text'>Home</p></a>
    <a href='/about-us'>
    <p className='f_text'>About</p></a>
    <a href='/services'>
     <p className='f_text'>Services</p></a>
     <a href='/blog'>
     <p className='f_text'>Blog</p></a>
     <a href='/contact-us'>
     <p className='f_text'>Contact Us</p></a>
</div>
<div>
    <h5 className='f_text1'>Our Services</h5>
    
    <a href='/web-development'>
    <p className='f_text'>Web Design & Development</p></a>
    <a href='/search-engine-optimization'>
    <p className='f_text'>SEO Optimization</p></a>
    <a href='/social-media-marketing'>
     <p className='f_text'>Social Media Marketing</p></a>
     <a href='/chat-bot-development'>
     <p className='f_text'>Chatbot Development</p></a>
      <a href='/data-and-automation-services'>
    <p className='f_text'>Data & Automation</p></a>
</div>
<div>
    <h5 className='f_text1'>Blog</h5>
    
    <a href='/search-engine-optimization-(seo)'>
    <p className='f_text'>SEO (Search Engine Optimization)</p></a>
    <a href='/How-Chatbots-Are-Revolutionizing-Modern-Organizations'>
    <p className='f_text'>How Chatbots Are Revolutionizing....</p></a>
    <a href='/Will-AI-replace-Digital-Marketing'>
    <p className='f_text'>Will AI replace Digital...</p></a>
</div>
<div>
  <div>
    <h5 className='f_text1'>Contact Us</h5>
    <a href="tel:9821778324">
    <p className='f_text'>9821778324</p></a>
    <a href="mailto:zweedoagency@gmail.com">
    <p className='f_text'>zweedoagency@gmail.com</p></a>
    <div className='social_div'>
<div className='d-flex'>
    <div className='social_icons'>
      <a target="_blank" rel="noopener noreferrer" href='https://www.linkedin.com/in/zweedo-agency-458846380?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app'>
<FaLinkedin className='f-icon'/></a>
</div>
 <div className='social_icons'>
  <a target="_blank" rel="noopener noreferrer" href='https://www.instagram.com/zweedo_agency?igsh=MW44bXBibHVha3dkbA=='>
<FaInstagramSquare className='f-icon' /></a>
</div>
<div className='social_icons'>
   <a 
    href="https://wa.me/9821778324" 
    target="_blank" 
    rel="noopener noreferrer"
  >
<FaWhatsappSquare className='f-icon'/></a>
</div>
</div>
</div>
</div>
</div>

            </div>
            <p className='f_text2'> Copyright © {year} Zweedo Marketing Agency. All Rights Reserved.</p>
            </div>

    </div>
  )
}

export default Footer